exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".studentDropdown[data-v-a5d8a06e]{width:30%}.dropdownContainer[data-v-a5d8a06e]{width:100%}.componentSeparator[data-v-a5d8a06e]{-webkit-box-flex:1!important;-ms-flex:auto!important;flex:auto!important}.mobileStyleAchievements[data-v-a5d8a06e]{min-width:600px}.roleContainer[data-v-a5d8a06e]{display:-webkit-box;display:-ms-flexbox;display:flex}.role[data-v-a5d8a06e]{padding-top:16px;margin-left:10%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a5d8a06e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/profile/Achievements.vue
// module id = 855
// module chunks = 0